export enum IconColor {
  Info = 'info',
  VectorAdaptiveDark = 'vectorAdaptiveDark',
  VectorAdaptivePrimary = 'vectorAdaptivePrimary',
  VectorAdaptiveBlueLight = 'vectorAdaptiveBlueLight',
  VectorAdaptiveBlueDark = 'vectorAdaptiveBlueDark',
  VectorAdaptiveOrange = 'vectorAdaptiveOrange',
  VectorAdaptiveRedLight = 'vectorAdaptiveRedLight',
  VectorAdaptiveWhite = 'vectorAdaptiveWhite',
  VectorStaticWhite = 'vectorStaticWhite',
  VectorAdaptiveGreyInverted = 'vectorAdaptiveGreyInverted',
  VectorAdaptiveGrey = 'vectorAdaptiveGrey',
  VectorAdaptivePurple = 'vectorAdaptivePurple',
  VectorAdaptiveGreenDark = 'vectorAdaptiveGreenDark',
  VectorAdaptiveSecondaryLight = 'vectorAdaptiveSecondaryLight',
  VectorAdaptiveGreenLight = 'vectorAdaptiveGreenLight',
  VectorAdaptiveDeepGreen = 'vectorAdaptiveDeepGreen',
  VectorAdaptiveTertiaryDark = 'vectorAdaptiveTertiaryDark',
  blueDark = 'blueDark',
  purpleDark = 'purpleDark',
  greenLight = 'greenLight',
  deepGreenDark = 'deepGreenDark',
  greyDark = 'greyDark',
  orange = 'orange',
}
